import React from 'react';
import PropTypes from 'prop-types';
import configHelper from 'helpers/config';

const ProductLocation = ({ coordinates: { lat, lng } }) => {
    const accessToken = configHelper.getMapBoxAccessToken();
    const url = `https://api.mapbox.com/styles/v1/mapbox/streets-v12/static/pin-s+F23760(${ lng },${ lat })/${ lng },${ lat },14/400x300?access_token=${ accessToken }`;

    return (
        <img src={ url } alt='Static Map' />
    );
};

ProductLocation.propTypes = {
    coordinates: PropTypes.shape({
        lat: PropTypes.number.isRequired,
        lng: PropTypes.number.isRequired,
    }).isRequired,
};

export default ProductLocation;


// WEBPACK FOOTER //
// ./src/pages/products/show/ProductLocation.js